export enum ContractStatus {
  PendingSignature = 'PendingSignature', // contract was sended to the teachers
  PreSigned = 'PreSigned', // teachers were send us the document POSIBLY signed because we dont know if the document is correctly signed
  Rejected = 'Rejected', // the contract received by us is wrong and staff set that status manually. After that we generate and send another contract
  Signed = 'Signed', // staff checked the document was correctly signed
  Cancelled = 'Cancelled', // staff cancels the contract at any time and it is not send again. We never gonna send that contract again
  Expired = 'Expired', // the contract has expired and a new contract must be generated and sent automatically
}
